// extracted by mini-css-extract-plugin
export default {"filter-item":"FilterItem_filter-item__iZ7N+","icon":"FilterItem_icon__TPXvE","icon-minus":"FilterItem_icon-minus__bSzFy","icon-plus":"FilterItem_icon-plus__AHG96"};